module.exports = __webpack_public_path__ + "static/img/yl.94c4f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yl.jpg
// module id = 1424
// module chunks = 1